module.exports = __webpack_public_path__ + "static/media/secure_data_icon.5f86f814.svg";